import { render, staticRenderFns } from "./goodsSaleStat_ec.vue?vue&type=template&id=75833244&scoped=true&"
import script from "./goodsSaleStat_ec.vue?vue&type=script&lang=js&"
export * from "./goodsSaleStat_ec.vue?vue&type=script&lang=js&"
import style0 from "./goodsSaleStat_ec.vue?vue&type=style&index=0&id=75833244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75833244",
  null
  
)

component.options.__file = "goodsSaleStat_ec.vue"
export default component.exports